<template>
  <VRow
    v-model="isConfirmDialogVisible"
    class="v-dialog-alert"
    :class="isConfirmDialogVisible ? 'active' : ''"
  >
    <div class="back-full-layer">
      <div class="alert-wrap bottom">
        <div class="tit-box">
          <div class="">{{ title }}</div>
          <div class="">{{ title2 }}</div>
          <div class="warning-txt">{{ warning }}</div>
        </div>
        <!-- 선택적 추가 영역 (예: 분석권 업셀). 슬롯 미사용 시 아무것도 렌더되지 않음 -->
        <slot name="extra" />
        <div class="btn-box bottom">
          <button class="btn-nor gray" @click="cancel">취소</button>
          <button class="btn-nor bottom left cancel" @click="onClickConfirm">{{ text }}</button>
        </div>
      </div>
    </div>
  </VRow>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { addContentLogAPI } from '@/api/logServiceApi';
import { useBackLayer } from '@/composables/useAppBack';

const router = useRouter();
const props = defineProps({
  title: String,
  title2: String,
  text: String,
  warning: String,
  nextUrl: Function,
  doUrl: Function,
  closeOpt: String,
  // 로그 관련 props
  logContentType: String, // 로그 contentType
  logCancelOption3: String, // 취소 버튼 클릭 시 option3 값
  logConfirmOption3: String, // 확인 버튼 클릭 시 option3 값
});

const isConfirmDialogVisible = ref(false);

const closeConfirmDialog = () => {
  if (props.nextUrl !== '') {
    isConfirmDialogVisible.value = false;
    props.nextUrl();
  }
  isConfirmDialogVisible.value = false;
};

const openConfirmDialog = () => {
  isConfirmDialogVisible.value = true;
};

const cancel = () => {
  if (props.logContentType && props.logCancelOption3) {
    addContentLogAPI({
      contentType: props.logContentType,
      option3: props.logCancelOption3,
    });
  }
  isConfirmDialogVisible.value = false;
};

useBackLayer({
  id: 'analysis-payment-confirm',
  isOpen: isConfirmDialogVisible,
  closeFromBack: cancel,
});

const onClickConfirm = () => {
  if (props.logContentType && props.logConfirmOption3) {
    addContentLogAPI({
      contentType: props.logContentType,
      option3: props.logConfirmOption3,
    });
  }
  isConfirmDialogVisible.value = false;
  if (props.doUrl) {
    props.doUrl();
  }
};

// 다이얼로그를 여는 메서드를 외부에서 호출할 수 있도록
defineExpose({ isConfirmDialogVisible, openConfirmDialog, dismissFromBack: cancel });
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center; /* 가운데 정렬 */
}
.v-dialog-alert .alert-wrap .btn-box.bottom {
  display: flex;
  justify-content: center;
  align-items: center;
}
.warning-txt {
  color: var(--orange-300-main, #eb4c10);
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 160% */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4px;
}
.btn-nor {
  display: flex;
  width: 162px !important;
  height: 48px;
  padding: 14px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--gray-100-white, #fff) !important;
  color: var(--Gray-800, #333) !important;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 20px;
  &.gray {
    background: var(--Gray-200, #f8f8f8) !important;
  }
  &.cancel {
    display: flex;
    width: 163px !important;
    height: 48px;
    padding: 14px 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 0px 0px 16px 0px;
    background: var(--orange-300-main, #eb4c10) !important;
    color: var(--gray-100-white, #fff) !important;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }
}
</style>
